import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetHealthSpecialtyEligibilityScript} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {GetHealthSpecialtyEligibilityScript} from 'domain/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthSpecialtyEligibilityScript = (): GetHealthSpecialtyEligibilityScript =>
	new RemoteGetHealthSpecialtyEligibilityScript(
		makeBFFApiUrl(BookingFlowEndPoints.healthSpecialtyEligibilityScript),
		makeAuthorizeHttpClientDecorator(),
	);
